exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification[data-v-789e2cf2]{font-size:1.6rem;line-height:1.7;strong[data-v-789e2cf2]{font-size:1.7rem;line-height:2}p[data-v-789e2cf2]{color:#6a6a6a}}", ""]);

// exports
